/**
 * Grobe Zeiger (Finger) ohne Maus: Tastaturhinweise wie „Strg+Enter“ sind dort Ballast (Audit F03). Bewusst ohne
 * Abo auf Änderungen – ein Gerät wechselt das selten, und die Hinweise sind nur Text.
 */
export const touchOnly = (): boolean => typeof matchMedia === 'function' && matchMedia('(pointer: coarse)').matches && !matchMedia('(any-pointer: fine)').matches;

/**
 * Etappe D (Leistung): Fensterhöhe zwischengespeichert – `innerHeight` im Rendern erzwingt sonst ein Layout (am Handy
 * ≈ 40 ms je Lesen bei einer frisch geänderten Seite).
 */
let height = typeof window === 'undefined' ? 900 : window.innerHeight;
if (typeof window !== 'undefined') window.addEventListener('resize', () => (height = window.innerHeight), { passive: true });
export const viewportHeight = () => height;
